export interface IMovementScheduleDates {
    balanceCloseDate: string; // ISO string
    balanceOpenDate: string; // ISO string
    incomeCloseDate: string;
    incomeOpenDate: string;
}
